import { Box, useTheme } from "@mui/material";
import React from "react";

interface MessageProp {
  children?: React.ReactNode;
  side: "left" | "right" | "center";
  src?: string;
}
const Message = ({ children, side, src }: MessageProp) => {
  const theme = useTheme();
  return (
    <Box
      component={src ? "img" : "div"}
      src={src}
      sx={{
        display: "block",
        width: src ? "42%" : "fit-content",
        maxWidth: "100%",
        overflowWrap: "break-word",
        ml: side === "right" ? "auto" : undefined,
        mr: side === "left" ? "auto" : undefined,
        mx: side === "center" ? "auto" : undefined,
        py: src ? "0" : "18px",
        px: src ? "0" : "25px",
        background: src
          ? "none"
          : side === "right"
          ? theme.colors.blue
          : side === "left"
          ? theme.colors.white
          : theme.colors.mainTheme,
        color:
          side === "right"
            ? theme.colors.lightFontColor
            : side === "left"
            ? theme.colors.darkFontColor
            : theme.colors.lightFontColor,
        borderRadius: src
          ? "8px"
          : side === "left"
          ? "0px 24px 24px 24px"
          : side === "right"
          ? "24px 0px 24px 24px"
          : theme.borderRadius.main,
        textAlign: side === "center" ? "center" : undefined,
        "&:hover": { cursor: src ? "zoom-in" : "default" },
      }}
    >
      {children}
    </Box>
  );
};

export default Message;
